<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
  <path d="M8.96158 12L14.6154 17.6538L15.6692 16.6L11.0692 12L15.6692 7.39998L14.6154 6.34616L8.96158 12Z"
        fill="#333333"/>
</svg>
</template>
